(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-part-relationship', {
            parent: 'entity',
            url: '/public-site-part-relationship?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePartRelationship.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationships.html',
                    controller: 'PublicSitePartRelationshipController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartRelationship');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-part-relationship-detail', {
            parent: 'entity',
            url: '/public-site-part-relationship/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePartRelationship.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-detail.html',
                    controller: 'PublicSitePartRelationshipDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartRelationship');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSitePartRelationship', function($stateParams, PublicSitePartRelationship) {
                    return PublicSitePartRelationship.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-part-relationship',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-part-relationship-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-dialog.html',
                    controller: 'PublicSitePartRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePartRelationship', function(PublicSitePartRelationship) {
                            return PublicSitePartRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part-relationship.new', {
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-dialog.html',
                    controller: 'PublicSitePartRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-part-relationship', null, { reload: 'public-site-part-relationship' });
                }, function() {
                    $state.go('public-site-part-relationship');
                });
            }]
        })
        .state('public-site-part-relationship.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-dialog.html',
                    controller: 'PublicSitePartRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePartRelationship', function(PublicSitePartRelationship) {
                            return PublicSitePartRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part-relationship', null, { reload: 'public-site-part-relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part-relationship.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-delete-dialog.html',
                    controller: 'PublicSitePartRelationshipDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSitePartRelationship', function(PublicSitePartRelationship) {
                            return PublicSitePartRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part-relationship', null, { reload: 'public-site-part-relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
